import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { PaymentTermsActions } from "./payment-terms.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// PAYMENT TERMS REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(PaymentTermsActions.load, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, loading: true, error: null },
})));

const loadSuccess = on(PaymentTermsActions.loadSuccess, (state: PagesStore, { paymentTerms }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, paymentTerms, loaded: true, loading: false, error: null },
})));

const invalidate = on(PaymentTermsActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, loaded: false },
})));

const loadFailure = on(PaymentTermsActions.loadFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, loading: false, error },
})));

const createPaymentTerm = on(PaymentTermsActions.createPaymentTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const createPaymentTermSuccess = on(PaymentTermsActions.createPaymentTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const createPaymentTermFailure = on(PaymentTermsActions.createPaymentTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error },
})));

const updatePaymentTerm = on(PaymentTermsActions.updatePaymentTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const updatePaymentTermSuccess = on(PaymentTermsActions.updatePaymentTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const updatePaymentTermFailure = on(PaymentTermsActions.updatePaymentTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error },
})));

const deletePaymentTerm = on(PaymentTermsActions.deletePaymentTerm, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const deletePaymentTermSuccess = on(PaymentTermsActions.deletePaymentTermSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error: null },
})));

const deletePaymentTermFailure = on(PaymentTermsActions.deletePaymentTermFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    paymentTerms: { ...superUserState.paymentTerms, error },
})));

export const paymentTermsReducer = [
    invalidate,
    load,
    loadSuccess,
    loadFailure,
    createPaymentTerm,
    createPaymentTermSuccess,
    createPaymentTermFailure,
    updatePaymentTerm,
    updatePaymentTermSuccess,
    updatePaymentTermFailure,
    deletePaymentTerm,
    deletePaymentTermSuccess,
    deletePaymentTermFailure,
];
